module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Boyqsb/tc-custom/9781426803802.jpg?1704825537089",
      "alt": "This image is the cover for the book Rich Man's Virgin, Expecting!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rich Man's Virgin, Expecting!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("She was a virgin and he got her pregnant.Now Australian millionaire Jack McKinnonwants to marry Maggie."), _c('br'), _c('br'), _vm._v("Maggie isn't about to let her life be takenover, however good Jack makes her feel!Only can she really take a stand now"), _c('i', [_vm._v("she's carrying Jack's baby?")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lindsay Armstrong\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lindsay Armstrong was born in South Africa. She grew up with three ambitions: to become a writer, to travel the world, and to be a game ranger. She managed two out of three! When Lindsay went to work it was in travel and this started her on the road to seeing the world. It wasn't until her youngest child started school that Lindsay sat down at the kitchen table determined to tackle her other ambition — to stop dreaming about writing and do it! She hasn't stopped since.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0